import React, { useEffect, useState } from "react";
import EpInlineLoader from "../common/EpInlineLoader";
import { createInternationalOrder } from "../../api/embassyGoodConductAppointment";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

function ShippingReviewStep({ values, setData, navigation, t }) {
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const sender = (values.shippingDetails && values.shippingDetails.sender) || {};
  const receiver = (values.shippingDetails && values.shippingDetails.receiver) || {};

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const setOverlayLoader = (status) => {
    setData({ name: "isLoading", value: status });
    setData({
      name: "loaderText",
      value: t("PLEASE_WAIT_WHILE_WE_REDIRECT_TO_PAYMENT_GATEWAY"),
    });
    if (status === true) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  };

  const handleContinueToPayment = async () => {
    setOverlayLoader(true);
    try {
      const { paymentUrl } = await createInternationalOrder({
        accessToken: values.accessToken,
        body: values.internationalOrderPayload,
      });
      window.location.href = paymentUrl;
    } catch (err) {
      const msg =
        err && typeof err.message === "string" && err.message.trim()
          ? err.message.trim()
          : t("UNEXPECTED_ERROR_OCCURED");
      setErrorMessage(msg);
      setModalShow(true);
      setOverlayLoader(false);
    }
  };

  const renderDetailRow = (label, value) => {
    if (!value) return null;
    return (
      <div className="col-sm-12 col-md-6 mb-4">
        <span>{label}</span>
        <span className="highlight">{value}</span>
      </div>
    );
  };

  const senderName = [sender.firstName, sender.lastName].filter(Boolean).join(" ");
  const receiverName = [receiver.firstName, receiver.lastName].filter(Boolean).join(" ");

  return (
    <>
      <Modal
        show={modalShow}
        aria-labelledby="shipping-review-error-modal"
        centered
      >
        <Modal.Header>
          <Modal.Title id="shipping-review-error-modal">
            {t("ERROR")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>{errorMessage}</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalShow(false)}>
            {t("CANCEL")}
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="row g-4">
        <div className="col-sm-12 col-lg-7">
          <div className="review-details p-4 mb-4">
            <h4>
              <img src="./images/user-icon.svg" alt="" />
              {t("SHIPPING_SENDER_TITLE")}
              <button
                className="btn btn-edit mx-3"
                onClick={() => navigation.go("shipping-sender")}
              >
                {t("EDIT")}
              </button>
            </h4>
            <div className="row mt-4">
              {renderDetailRow(t("NAME"), senderName)}
              {renderDetailRow(t("EMAIL_ADDRESS"), sender.email)}
              {renderDetailRow(t("MOBILE_NUMBER"), sender.mobile)}
              {renderDetailRow(t("SHIPPING_CITY"), sender.cityName || sender.city)}
              {renderDetailRow(t("SHIPPING_AREA"), sender.area)}
              {renderDetailRow(t("SHIPPING_STREET"), sender.street)}
              {renderDetailRow(t("SHIPPING_BUILDING"), sender.building)}
              {renderDetailRow(t("SHIPPING_FLOOR"), sender.floor)}
              {renderDetailRow(t("SHIPPING_APARTMENT"), sender.apartmentNo)}
              {renderDetailRow(t("SHIPPING_ZIP"), sender.zip)}
              {renderDetailRow(t("SHIPPING_ADDITIONAL_ADDRESS"), sender.additionalAddress)}
            </div>
          </div>

          <div className="review-details p-4 mb-4">
            <h4>
              <img src="./images/user-icon.svg" alt="" />
              {t("SHIPPING_RECEIVER_TITLE")}
              <button
                className="btn btn-edit mx-3"
                onClick={() => navigation.go("shipping-receiver")}
              >
                {t("EDIT")}
              </button>
            </h4>
            <div className="row mt-4">
              {renderDetailRow(t("NAME"), receiverName)}
              {renderDetailRow(t("EMAIL_ADDRESS"), receiver.email)}
              {renderDetailRow(t("MOBILE_NUMBER"), receiver.mobile)}
              {receiver.companyName && renderDetailRow(t("SHIPPING_COMPANY_NAME"), receiver.companyName)}
              {renderDetailRow(t("SHIPPING_COUNTRY"), receiver.country)}
              {renderDetailRow(t("SHIPPING_STATE_REGION"), receiver.state)}
              {renderDetailRow(t("SHIPPING_CITY"), receiver.cityName || receiver.city)}
              {renderDetailRow(t("SHIPPING_AREA"), receiver.area)}
              {renderDetailRow(t("SHIPPING_STREET"), receiver.street)}
              {renderDetailRow(t("SHIPPING_BUILDING"), receiver.building)}
              {renderDetailRow(t("SHIPPING_FLOOR"), receiver.floor)}
              {renderDetailRow(t("SHIPPING_APARTMENT"), receiver.apartmentNo)}
              {renderDetailRow(t("SHIPPING_ZIP"), receiver.zip)}
              {renderDetailRow(t("SHIPPING_ADDITIONAL_ADDRESS"), receiver.additionalAddress)}
            </div>
          </div>

          <div className="col-6 my-3 dir-left">
            <button
              type="button"
              className="btn btn-lg btn-default btn-back"
              onClick={() => navigation.go("shipping-receiver")}
            >
              <img src="./images/arrow-left.svg" alt="" />
              {t("BACK")}
            </button>
          </div>
        </div>

        <div className="col-sm-12 col-md-6 col-lg-5 payment-details-sec">
          <div className="review-details p-4">
            <div className="col-sm-12 mb-2">
              <span>{t("SERVICE_NAME")}</span>
              <span className="highlight">{values.serviceTypeName}</span>
            </div>
          </div>

          <div className="payment-details p-4">
            <div className="row total-price-section">
              <div className="col-7 dir-left d-flex align-items-center">{t("TOTAL_AMOUNT")}</div>
              <div className="col-5 dir-right">
                <span className="total-amount">
                  {t("AED")} {parseFloat(values.totalAmount || 0).toFixed(2)}
                </span>
              </div>
            </div>
          </div>

          <div className="col-sm-12 my-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="shipping-accept-terms"
                onChange={() => setAcceptedTerms((prev) => !prev)}
              />
              <label className="form-check-label" htmlFor="shipping-accept-terms">
                <a
                  href="https://www.emx.ae/terms-and-conditions"
                  target="_blank"
                  className="a-link"
                  rel="noreferrer"
                >
                  <h5>{t("TERMS_CONDITIONS")}</h5>
                </a>
              </label>
            </div>
          </div>

          <div className="col-sm-12 mt-3 d-grid">
            <button
              className="btn btn-primary btn-lg d-block emx-button"
              onClick={handleContinueToPayment}
              disabled={!acceptedTerms || values.isLoading}
            >
              {values.isLoading ? (
                <div><EpInlineLoader /></div>
              ) : (
                <div className="row">
                  <div className="col-10 dir-left">{t("CONTINUE_TO_PAYMENT")}</div>
                  <div className="col-2 dir-right">
                    <img src="./images/btn-arrow-right.svg" alt="" className="payment-arrow" />
                  </div>
                </div>
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ShippingReviewStep;
